'use client';
import React, { useState } from 'react';
import JsonView from '@/components/JsonView';
import { NODE_ENV } from '@/config/environment';
import tracking from '@/lib/tracking';
import * as Styled from './styled';
import { CodeIcon } from '@radix-ui/react-icons';

const getComponentStack = (errorInfo) => {
  const stack = errorInfo?.componentStack.split('\n'); //.map((line) => line.trim().replace(/(^at )/gi, ''));
  return stack;
};

const filterOutNodeModules = (stack) => {
  return stack?.filter((line) => !line.includes('/node_modules/'));
};

const filterOutHtmlNodes = (stack) => {
  return stack?.filter((line) => line.includes('(webpack-internal:'));
};

const filterOutNextNodes = (stack) => {
  return stack?.filter((line) => !line.includes('/node_modules/next'));
};

const getOuterStack = (errorInfo) => {
  return filterOutHtmlNodes(filterOutNodeModules(getComponentStack(errorInfo)));
};

const getInnerStack = (error) => {
  const stack = error?.stack ? error.stack.split('\n') : [];
  return filterOutNextNodes(stack);
};

const DevErrorBoundary = ({ fallback, error, innerStack, outerStack }) => {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <Styled.DevErrorBoundary>
      <Styled.ErrorBoundaryHeader>
        <CodeIcon onClick={() => setShowDetails(!showDetails)} />
      </Styled.ErrorBoundaryHeader>
      {fallback}
      {showDetails && (
        <Styled.ErrorBoundaryWrapper onClick={() => setShowDetails(!showDetails)}>
          <Styled.ErrorBoundary onClick={(e) => e.stopPropagation()}>
            <h5 style={{ color: 'red' }}>Error Details</h5>
            <br />
            <JsonView json={{ env: NODE_ENV }} rootNodeName="env" />
            <JsonView json={error} rootNodeName="error" />
            <JsonView json={innerStack} rootNodeName="innerStack" />
            <JsonView json={outerStack} rootNodeName="outerStack" />
          </Styled.ErrorBoundary>
        </Styled.ErrorBoundaryWrapper>
      )}
    </Styled.DevErrorBoundary>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // const componentName = this.props.children.type?.name;
    const outerStack = getOuterStack(errorInfo);
    const innerStack = getInnerStack(error);

    // const title = componentName || 'Unknown Component';

    tracking.capture('Error Boundary Hit', {
      title: this.props.containerComponent,
      error: error.toString(),
      // containerComponent: this.props.containerComponent,
      outerStack,
      innerStack,
    });

    // console.log('errorInfo', errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      const env = NODE_ENV;
      console.log('env', env);
      if (env !== 'development') {
        return this.props.fallback;
      }

      const { error, errorInfo } = this.state;
      const outerStack = getOuterStack(errorInfo);
      const innerStack = getInnerStack(error);

      return (
        <DevErrorBoundary
          fallback={this.props.fallback}
          error={error}
          innerStack={innerStack}
          outerStack={outerStack}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
